import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { CustomerTable } from '@/components/features/organizations';

/**
 * Pages in this portal are thin on purpose: set the title, compose feature
 * components, nothing else. The substance lives in components/features/, where
 * it can be tested without mounting a router.
 */
export function CustomersPage() {
  return (
    <>
      <Meta title="Customers" />

      {/*
        No page heading - the shell's 80px header already carries "Users &
        Licences", and a second one under it is duplication.
      */}
      <Container>
        <CustomerTable />
      </Container>
    </>
  );
}
